import { useCallback } from "react";

export interface ReportsData {
  summary: any[];
  overUsage: any[];
  unused: any[];
  depleted: any[];
  overtime: any[];
  division: any[];
}

type PersistedCache = {
  [month: string]: ReportsData;
};

const persistedCache: PersistedCache = {};

export const useReportsCache = () => {
  const getReportsData = useCallback((month: string): ReportsData | null => {
    return persistedCache[month] || null;
  }, []);

  const setReportsData = useCallback((month: string, data: ReportsData) => {
    persistedCache[month] = data;
  }, []);

  return { getReportsData, setReportsData };
};
